module.exports = __webpack_public_path__ + "static/Supply-Chain-c292530f2f63579148f757bc9abaf28f.jpg";